import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

// project imports
import { useAuth } from "../../../utils/auth";
import { useEffect } from "react";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuardNotCustomer = ({ children }) => {
  const { user } = useAuth();
  const haveObchodRole = user
    ? JSON.stringify(user.roles).includes("obchod")
    : false;
  const isAdmin = user ? JSON.stringify(user.roles).includes("admin") : false;
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("login");
    }
    if (user && !haveObchodRole && !isAdmin) {
      navigate("/app/not-allowed");
    }
  }, [user, navigate]);

  return children;
};

AuthGuardNotCustomer.propTypes = {
  children: PropTypes.node,
};

export default AuthGuardNotCustomer;
